module.exports = __webpack_public_path__ + "static/media/tutellus.34ac67ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners/images/tutellus.png
// module id = 1681
// module chunks = 146